module.exports = "https://dev.stanwinstonschool.com/thehungergames.7d18f6c88c30dead7f6e1f430c40c4ab.jpg";